module.exports = __webpack_public_path__ + "media/images/manifest/microbius-72-0056d385d6212775cdd1651782a0f53b.png";